export enum ScreenSize {
  xs,
  sm,
  md,
  lg,
  xl,
}
